import { useUserStore } from '@/stores/user';
import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';
import { useAppStore } from '@/stores/app';
import { BetSelection, Platform } from '@/constants';
import { getPlatform } from '@/helpers/getPlatform';
import { AppError } from '@/errors/appError';

export function getCountryFlagUrl(iso3: string) {
    // return new URL(`/src/assets/images/flags/countries/${iso3}.png`, import.meta.url).href;
    return `/images/flags/countries/${iso3}.png`;
}

export function getTeamLogoUrl(logoName: string) {
    // return new URL(`/src/assets/teams/${logoName}`, import.meta.url).href;
    return `/teams/${logoName}`;
}

export function formatOdds(odds: string | number, precision = 3) {
    //if (!odds) return '';

    //let oddsArr = (odds + '').split('.');
    //return oddsArr[0] + '.' + (oddsArr[1] ? oddsArr[1].slice(0, precision).padEnd(precision, '0') : ''.padStart(precision, '0'));

    //faster
    const x = 10 ** precision;
    return (Math.trunc(Number(odds) * x) / x).toFixed(precision);
}

export function formatMoney(value: string | number) {
    return Number(value)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export function dateFormatInUserTimeZone(date: Date | string | number, formatStr: string): string {
    const userStore = useUserStore();
    const timeZone = userStore.isLoggedIn() ? userStore.timeZone : 'Europe/London';

    //if date instanceof Date, we assume that this date was created in JS in local time and no need to convert time to fromZonedTime
    if (!(date instanceof Date)) {
        date = fromZonedTime(date, 'Europe/London'); //'Europe/London' here is our DB timezone
    }

    return formatInTimeZone(date, timeZone, formatStr, { locale: userStore.dateFnsLocale });
}

export function playSound(url: string) {
    const audio = new Audio(url);
    audio.play();
}

export function getWebSocketURL(token: string) {
    const appStore = useAppStore();
    return (
        (location.protocol === 'http:' ? 'ws' : 'wss') + '://' + location.hostname + ':' + location.port + '/ws?token=' + token + '&appId=' + appStore.uniqAppId /* +
            (store.state.AppModule.isInitialized === false ? '&init=true' : '')*/
    );
}

export function pageReload() {
    if (getPlatform() === Platform.Tradeball) {
        window.location.reload();
    } else {
        let protocol = window.location.protocol + '//';
        let domain = window.location.hostname.replace('tradeball.', '');
        let url = protocol + domain + '/tradeball' + window.location.pathname;
        console.log('Location replace url: ' + url);
        window.parent.location.replace(url);
    }
}

export function getBetTypeIdByBetSelection(betSelectionId: number): number {
    if ([BetSelection.HandicapHome, BetSelection.HandicapAway].includes(betSelectionId)) return 1; // Asian Handicap
    if ([BetSelection.GoalOver, BetSelection.GoalUnder].includes(betSelectionId)) return 2; // Over/Under
    if ([BetSelection.OneXTwoHome, BetSelection.OneXTwoDraw, BetSelection.OneXTwoAway].includes(betSelectionId)) return 3; // 1X2
    if ([BetSelection.BtsYes, BetSelection.BtsNo].includes(betSelectionId)) return 4; // Both Teams To Score
    if ([BetSelection.Dc1X, BetSelection.DcX2, BetSelection.Dc12].includes(betSelectionId)) return 5; // Double Chance
    if (betSelectionId === BetSelection.Cs) return 6; // Correct Score
    if ([BetSelection.CornersHandicapHome, BetSelection.CornersHandicapAway].includes(betSelectionId)) return 7; // Corners Asian Handicap
    if ([BetSelection.CornersGoalOver, BetSelection.CornersGoalUnder].includes(betSelectionId)) return 8; // Corners Over/Under

    throw new AppError('Unknown betTypeId for betSelectionId: ' + betSelectionId);
}

export function getHandicapKeyByBetSelection(betSelectionId: number): string | null {
    if ([BetSelection.HandicapHome, BetSelection.HandicapAway].includes(betSelectionId)) return 'hdV'; // Asian Handicap
    if ([BetSelection.GoalOver, BetSelection.GoalUnder].includes(betSelectionId)) return 'ouV'; // Over/Under
    // if ([BetSelection.CornersHandicapHome, BetSelection.CornersHandicapAway].includes(betSelectionId)) return 7; // Corners Asian Handicap
    // if ([BetSelection.CornersGoalOver, BetSelection.CornersGoalUnder].includes(betSelectionId)) return 8; // Corners Over/Under

    return null;
}

export function sleep(time: number) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

export function londonToGMT(datetimeStr: string): string {
    const naiveIso = datetimeStr.replace(' ', 'T'); // "2025-10-28T11:00:00"
    const utcDate = fromZonedTime(naiveIso, 'Europe/London');

    return formatInTimeZone(utcDate, 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSS");
}
